export default "__VITE_ASSET__CoMp128l__"